import { useEffect, useState } from 'react';
import { Flex, Text } from '../../../2022-component-library';
import { VideoChat } from '../../../components';
import { useReceiveMessage } from '../../../context/messageContext';

const customStyle = {
  videoBox: {
    position: 'fixed',
    top: 0,
    left: 0,
    visibility: 'hidden',
  },
  localParticipant: {
    width: 'auto',
    height: 'auto',
  },
};

const ResponsiveOptimaChartTestPatient = () => {
  const [optimaData, setOptimaData] = useState({});
  const getStyleValues = (textContent) => {
    const styleValues = {};

    styleValues['borderWidth'] = parseInt(textContent.value) / 8 ? parseInt(textContent.value) / 8 : 1;
    styleValues['borderStyle'] = 'solid';
    styleValues['padding'] = parseInt(textContent.key.replace('n', '')) / 3;
    styleValues['margin'] = (window.screen.availHeight - 3 * parseInt(textContent.key.replace('n', ''))) / 22 + 'px';
    styleValues['fontFamily'] = 'Times New Roman';

    return styleValues;
  };
  const receivedMessage = useReceiveMessage();

  useEffect(() => {
    if (receivedMessage?.type === 'optimaTextContents')
      setOptimaData({
        textContents: receivedMessage.content.textContents.fontSizes,
      });
  }, [receivedMessage]);

  return (
    <Flex width='100vw' height='100vh' justifyContent='center'>
      <Flex column maxWidth='75vw'>
        <VideoChat stacked customStyle={customStyle} />
        {optimaData.textContents?.map((textContent) => {
          return (
            <Text textAlign='left' key={`optima-text-${textContent.content}`} fontSize={textContent.value} style={getStyleValues(textContent)}>
              {textContent.content}
            </Text>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default ResponsiveOptimaChartTestPatient;
